import { useFile } from '../api';
import { useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components';
import FileContainer from '../components/FileContainer';

const File = () => {
  const { id } = useParams(); // Access the dynamic part of the route
  const { error, data } = useFile(id as string); // id is always filled, otherwise NoPage.tsx is rendered
  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading file..."
      error={error}
      errorMessage="Loading file failed!"
      render={(data) => (
        <FileContainer file={data.file} permissions={data.permissions} resolvedItems={data.resolvedItems} />
      )}
    />
  );
};

export default File;
